module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    class: _vm.plungeClass,
    attrs: {
      "id": "mainDiv"
    }
  }, [(this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "VUIformInputDivID"
    }
  }, [_c('div', {
    staticClass: "col-xs-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userVoiceToText),
      expression: "userVoiceToText"
    }],
    staticClass: "form-control",
    class: _vm.plungeClass,
    staticStyle: {
      "color": "white !important",
      "border-width": "0px"
    },
    attrs: {
      "type": "text",
      "id": "inlineFormInputGroupUsername2",
      "placeholder": "View & Type Voice Commands Here"
    },
    domProps: {
      "value": (_vm.userVoiceToText)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.userVoiceToTextFunc($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userVoiceToText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [(_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-microphone-slash",
    attrs: {
      "id": "speechEngage"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.initSpeech) ? _c('span', {
    on: {
      "click": _vm.speechStartStopFunc
    }
  }, [_c('i', {
    staticClass: "fa fa-microphone-alt",
    style: ({
      'color': _vm.recognizing ? 'red' : 'black'
    }),
    attrs: {
      "id": "speechEngageActivated"
    }
  })]) : _vm._e()])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterContainer),
      expression: "showEnterContainer"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "enterContainer"
    }
  }, [_c('transition', {
    attrs: {
      "appear": "",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated zoomOutUp",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEnterBtn),
      expression: "showEnterBtn"
    }],
    staticClass: "btn-info",
    staticStyle: {
      "color": "black",
      "background-color": "#ecdbc5"
    },
    attrs: {
      "id": "enterFuncBtn"
    },
    on: {
      "~click": function($event) {
        return _vm.enterFunc($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tARID TONALITY\n\t\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }],
    staticStyle: {
      "color": "white",
      "border-color": "transparent",
      "background": "transparent"
    },
    attrs: {
      "id": "enterFuncBtn"
    }
  }, [_vm._v(" \t\n\t\t\t\t\t\t\tLoading... \n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.whatIsLoading) + "\n\t\t\t\t\t")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllControls),
      expression: "showAllControls"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "controlsContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "ambienceBtnLocation"
    }
  }, [(!_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tAdd "), _c('i', {
    staticClass: "fal fa-check-circle"
  }), _vm._v(" or Remove "), _c('i', {
    staticClass: "fal fa-times-circle"
  }), _vm._v(" Sounds From Your "), _c('span', {
    attrs: {
      "id": "soundscapeTitleBreak"
    }
  }, [_vm._v("Mojave Desert Soundscape")])]) : (_vm.userMobile) ? _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle"
    }
  }, [_vm._v(" \n\t\t\t\t\t\t\tSounds of the Mojave Desert")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn1Div"
    }
  }, [_c('button', {
    class: _vm.ambience1Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience1Func
    },
    on: {
      "click": function($event) {
        _vm.ambience1Boolean = !_vm.ambience1Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience1Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tOasis\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience1Vol),
      expression: "ambience1Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance1RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience1Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience1Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience1Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn2Div"
    }
  }, [_c('button', {
    class: _vm.ambience2Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience2Func
    },
    on: {
      "click": function($event) {
        _vm.ambience2Boolean = !_vm.ambience2Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience2Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCarcass\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience2Vol),
      expression: "ambience2Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance2RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience2Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience2Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience2Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn3Div"
    }
  }, [_c('button', {
    class: _vm.ambience3Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience3Func
    },
    on: {
      "click": function($event) {
        _vm.ambience3Boolean = !_vm.ambience3Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience3Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tCoyotes\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience3Vol),
      expression: "ambience3Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance3RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience3Func,
      "max": "2",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience3Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience3Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn4Div"
    }
  }, [_c('button', {
    class: _vm.ambience4Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience4Func
    },
    on: {
      "click": function($event) {
        _vm.ambience4Boolean = !_vm.ambience4Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience4Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDesert Winds\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience4Vol),
      expression: "ambience4Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance4RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience4Func,
      "max": "8",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience4Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience4Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn5Div"
    }
  }, [_c('button', {
    class: _vm.ambience5Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience5Func
    },
    on: {
      "click": function($event) {
        _vm.ambience5Boolean = !_vm.ambience5Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience5Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tAirplane\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience5Vol),
      expression: "ambience5Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance5RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience5Func,
      "max": "6",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience5Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience5Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "ambienceBtn6Div"
    }
  }, [_c('button', {
    class: _vm.ambience6Class,
    attrs: {
      "id": "ambienceBtns",
      "": _vm.ambience6Func
    },
    on: {
      "click": function($event) {
        _vm.ambience6Boolean = !_vm.ambience6Boolean;
        _vm.randomizeBoolean = false;
      }
    }
  }, [_c('i', {
    class: _vm.ambience6Icon
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDesert Walk\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.ambience6Vol),
      expression: "ambience6Vol",
      modifiers: {
        "number": true
      }
    }],
    class: _vm.ambiance6RangerClass,
    attrs: {
      "id": "ambienceSlider",
      "type": "range",
      "": _vm.ambience6Func,
      "max": "0",
      "min": "-50",
      "step": "1"
    },
    domProps: {
      "value": (_vm.ambience6Vol)
    },
    on: {
      "__r": function($event) {
        _vm.ambience6Vol = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "masterControlDiv"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "fxTitle2"
    }
  }, [_vm._v(" \n\t\t\tProcess Soundscape With Digital Audio Processing\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice1SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.speedToggle = !_vm.speedToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.speedToggle),
      expression: "speedToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.speedToggle),
      expression: "!speedToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tSpeed " + _vm._s(((_vm.playBackSpeed).toFixed(3))) + "x \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.playBackSpeed),
      expression: "playBackSpeed",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders6",
      "type": "range",
      "step": "0.01",
      "max": "2",
      "min": "0.1",
      "": _vm.playbackSpeedFunc
    },
    domProps: {
      "value": (_vm.playBackSpeed)
    },
    on: {
      "__r": function($event) {
        _vm.playBackSpeed = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice2SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxDelayToggle = !_vm.fxDelayToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxDelayToggle),
      expression: "fxDelayToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxDelayToggle),
      expression: "!fxDelayToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tDelay " + _vm._s(_vm.fxDelayAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxDelayAmt),
      expression: "fxDelayAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders2",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxDelayMix
    },
    domProps: {
      "value": (_vm.fxDelayAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxDelayAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice3SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxChorusToggle = !_vm.fxChorusToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxChorusToggle),
      expression: "fxChorusToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxChorusToggle),
      expression: "!fxChorusToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tChorus " + _vm._s(_vm.fxChorusAmt) + "% \n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxChorusAmt),
      expression: "fxChorusAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders3",
      "type": "range",
      "step": "1",
      "max": "100",
      "min": "0",
      "": _vm.fxChorusMix
    },
    domProps: {
      "value": (_vm.fxChorusAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxChorusAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice4SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxFilterToggle = !_vm.fxFilterToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxFilterToggle),
      expression: "fxFilterToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxFilterToggle),
      expression: "!fxFilterToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tFilter " + _vm._s(_vm.fxAutoFilterAmt) + "Hz\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxAutoFilterAmt),
      expression: "fxAutoFilterAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders4",
      "type": "range",
      "step": "1",
      "max": "10000",
      "min": "80",
      "": _vm.fxAutoFilterMix
    },
    domProps: {
      "value": (_vm.fxAutoFilterAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxAutoFilterAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userMobile),
      expression: "!userMobile"
    }],
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice5SliderDiv"
    }
  }, [_c('button', {
    staticClass: "voiceBadgeDesert",
    attrs: {
      "id": "masterControlBadges"
    },
    on: {
      "click": function($event) {
        _vm.fxConvolverToggle = !_vm.fxConvolverToggle
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fxConvolverToggle),
      expression: "fxConvolverToggle"
    }],
    staticStyle: {
      "color": "black"
    }
  }, [_c('i', {
    staticClass: "far fa-check-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fxConvolverToggle),
      expression: "!fxConvolverToggle"
    }],
    staticStyle: {
      "color": "var(--main-stopDesert-color)"
    }
  }, [_c('i', {
    staticClass: "far fa-times-circle"
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\tReverb (" + _vm._s(((_vm.fxDecay).toPrecision(2))) + "s) " + _vm._s((_vm.fxConvolverAmt * 2)) + "%\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.fxConvolverAmt),
      expression: "fxConvolverAmt",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "instrumentRangerDesert",
    attrs: {
      "id": "sliders1",
      "type": "range",
      "step": "1",
      "max": "50",
      "min": "0",
      "": _vm.fxConvolverMix
    },
    domProps: {
      "value": (_vm.fxConvolverAmt)
    },
    on: {
      "__r": function($event) {
        _vm.fxConvolverAmt = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2",
    attrs: {
      "id": "voice6SliderDiv"
    }
  }, [_c('button', {
    class: _vm.mattChillClass,
    attrs: {
      "id": "masterControlBadgesSFX"
    },
    on: {
      "click": _vm.mattChillMethod
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.randomizeBoolean),
      expression: "!randomizeBoolean"
    }]
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Randomize "), _c('i', {
    staticClass: "fa fa-flask"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.randomizeBoolean),
      expression: "randomizeBoolean"
    }]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask5),
      expression: "showFlask5"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask3),
      expression: "showFlask3"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask1),
      expression: "showFlask1"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask2),
      expression: "showFlask2"
    }],
    staticClass: "fa fa-flask slow-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask4),
      expression: "showFlask4"
    }],
    staticClass: "fa fa-flask fa-spin"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlask6),
      expression: "showFlask6"
    }],
    staticClass: "fa fa-flask fa-counter-spin"
  })])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAboutPage),
      expression: "showAboutPage"
    }],
    staticClass: "col-xs-12",
    attrs: {
      "id": "aboutPageID"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "aboutTxt"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tJoshua Tree is an absolutely mesmerizing landscape, and not only because of the beautifully strange Yucca trees. It is here that two deserts converge, the Colorado Desert and the Mojave Desert. In Joshua Tree these two deserts twist together and form a unique landscape with an equally unique soundscape. \n\t\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tDuring the day you will hear the delightful song birds, with a good concentration of them in the region's oases. However, the soundscape evolves once twilight sets into the horizon. In the evening, coyote’s make their calls heard throughout the soundscape. Their distinct calls and songs bounce off huge boulders and rock faces, creating beautiful echos.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "id": "disclaimerTxt"
    }
  }, [_vm._v("\n\t\t\t\t\t\tSound Design & Recordings Copyright © 2018 "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.mattmccorkle.com",
      "target": "_blank"
    }
  }, [_vm._v("Matt McCorkle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(" These sounds are presented here for personal entertainment use only. ")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t\tFor commercial sound licensing email hi@mattmccorkle.com\n\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID2"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-window-close fa-3x"
  })])])])]), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div') : _vm._e(), _vm._v(" "), (this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated pulse",
      "mode": "out-in"
    }
  }, [(_vm.showSpeechBtns) ? _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "speechContainer"
    }
  }, [_c('button', {
    class: _vm.speechShowListClass,
    attrs: {
      "id": "speechList"
    },
    on: {
      "click": _vm.voiceCommandListFunc
    }
  }, [_c('i', {
    staticClass: "fal fa-clipboard-list"
  }), _vm._v(" List of Voice Commands\n\t\t\t\t")]), _vm._v(" "), (_vm.showVoiceCommandList) ? _c('div', {
    attrs: {
      "id": "voiceCommandListID"
    }
  }, [_c('p', {
    attrs: {
      "id": "voiceControlListTitle"
    }
  }, [_c('strong', [_vm._v(" Voice Control This Immersive Experience")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "voiceControlListTxt"
    }
  }, [_c('strong', [_vm._v("Allow Google Chrome Microphone Access To Use This Feature")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" Voice Control Works "), _c('strong', [_c('u', [_vm._v("Great")])]), _vm._v(" With Headphones "), _c('i', {
    staticClass: "fal fa-headphones"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("OK! Now Use That Beautiful Voice, Say Something!\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('u', [_vm._v("Exploration:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tLet's Explore!\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tRandomize, Shift Soundscape,")]), _vm._v(" or "), _c('strong', [_vm._v("New Scene")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Creating A Soundscape:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Oasis")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Carcass")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Coyotes")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Desert Winds")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Airplane")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Play")]), _vm._v(" or "), _c('strong', [_vm._v("Add In")]), _vm._v(" "), _c('i', [_vm._v("Desert Walk")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Stop ")]), _vm._v(" or "), _c('strong', [_vm._v("Take Out ")]), _vm._v("[Sound Source Name] \n\t\t\t\t\t"), _c('br'), _c('span', {
    attrs: {
      "id": "voiceListAnchor"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Volume Up")]), _vm._v(" or "), _c('strong', [_vm._v("Louder")]), _vm._v(" [Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Volume Down")]), _vm._v(" or "), _c('strong', [_vm._v("Softer ")]), _vm._v("[Sound Source Name]\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Digital Audio Effects:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Speed Up ")]), _vm._v("or "), _c('strong', [_vm._v("Faster")]), _vm._v(" & "), _c('strong', [_vm._v("Speed Down ")]), _vm._v("or "), _c('strong', [_vm._v("Slower")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delay On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Chorus On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Filter On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reverb On")]), _vm._v(" or "), _c('strong', [_vm._v("Off ")]), _vm._v(" & "), _c('strong', [_vm._v("More ")]), _vm._v("or "), _c('strong', [_vm._v("Less")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Add the word "), _c('strong', [_vm._v("a lot")]), _vm._v(" to move in greater increments.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Housekeeping:")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tStop All Sounds \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tPlay All Sounds\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tStop Voice Commands \n\t\t\t\t\t"), _c('br'), _vm._v(" \n\t\t\t\t\tGo Home\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Soundscape Info\n\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\tShow")]), _vm._v(" or "), _c('strong', [_vm._v("Hide Voice Command List")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_c('u', [_vm._v("Additional Mentions:")])]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t1.) It might take a few tries, try saying your command quickly and in a direct manner.\n\t\t\t\t\t"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\t2.) Each Sound Source can always be addressed as \"Sound Source 1-6\"\n\t\t\t\t")])]) : _vm._e()]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!this.$store.state.allowSpeechControl) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid"
  }, [_c('button', {
    class: _vm.exploreFuncClass,
    attrs: {
      "id": "exploreBtnId"
    },
    on: {
      "click": _vm.exploreBtnFunc
    }
  }, [_c('i', {
    class: _vm.exploreIconClass
  }), _vm._v(" " + _vm._s(_vm.exploreTxt) + "\n\t\t\t\t")])])])], 1) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "localStorageBtnsKey",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.saveClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.setLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Save\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.loadClass,
    attrs: {
      "id": "localStorageBtnID"
    },
    on: {
      "click": _vm.getLocalStorage
    }
  }, [_c('i', {
    staticClass: "fal fa-sliders-h"
  }), _vm._v(" Load\n\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    key: "helpBtnsKeys",
    staticClass: "container-fluid",
    attrs: {
      "id": "helpContainer"
    }
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goToHelp
    }
  }, [_c('i', {
    staticClass: "fal fa-info-circle"
  }), _vm._v(" Info\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('button', {
    class: _vm.helpClass,
    attrs: {
      "id": "aboutBtnID"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  }), _vm._v(" Home\n\t\t\t\t\t")])])])]), _vm._v(" "), (!_vm.userMobile) ? _c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNavBar),
      expression: "showNavBar"
    }],
    staticClass: "container-fluid",
    attrs: {
      "id": "visualToggleContainer"
    }
  }, [(_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-on"
  })]) : (!_vm.activeSun) ? _c('span', {
    attrs: {
      "id": "visualToggle"
    },
    on: {
      "click": function($event) {
        _vm.activeSun = !_vm.activeSun
      }
    }
  }, [_vm._v(" \n\t\t\t\t\t\tReactive Background\n\t\t\t\t\t\t"), _c('i', {
    staticClass: "fal fa-toggle-off"
  })]) : _vm._e()])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebf32f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/desert.vue
// module id = 59
// module chunks = 0